// components/modals/PasswordModals/PasswordFormModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import '../../../styles/components/modals.css';
import useModalHistory from '../../../hooks/useModalHistory';

const PasswordFormModal = ({
    show,
    onHide,
    initialData,
    isEditing = false,
    onSave,
    isLoading = false
}) => {

    useModalHistory(show, onHide, 'password-form-modal');

    const [formData, setFormData] = useState({
        alias: '',
        userID: '',
        password: '',
        accountNumber: '',
        contactNumber: '',
        contactName: ''
    });
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        } else {
            // Reset form for new entries
            setFormData({
                alias: '',
                userID: '',
                password: '',
                accountNumber: '',
                contactNumber: '',
                contactName: ''
            });
        }
    }, [initialData, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        onSave(formData, formData.originalName);
    };

    const generatePassword = () => {
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=";
        let newPassword = "";
        for (let i = 0; i < 32; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            newPassword += charset[randomIndex];
        }
        setFormData(prev => ({ ...prev, password: newPassword }));
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            className="common-modal" // Add this class
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>{isEditing ? 'Edit Password' : 'Add Password'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="password-form" onSubmit={handleSubmit} autoComplete="off">
                    <Form.Group className="mb-4">
                        <Form.Label className="form-label">Password Alias:</Form.Label>
                        <Form.Control
                            type="text"
                            name="alias"
                            value={formData.alias}
                            onChange={handleChange}
                            className="form-input"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label className="form-label">UserID:</Form.Label>
                        <Form.Control
                            type="text"
                            name="userID"
                            value={formData.userID}
                            onChange={handleChange}
                            className="form-input"
                            autoComplete="nope"
                            required
                            data-lpignore="true" 
                            data-form-type="other"
                        />
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label className="form-label">Account Number:</Form.Label>
                        <Form.Control
                            type="text"
                            name="accountNumber"
                            value={formData.accountNumber}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Optional"
                        />
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label className="form-label">Contact Number:</Form.Label>
                        <Form.Control
                            type="text"
                            name="contactNumber"
                            value={formData.contactNumber}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Optional"
                        />
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label className="form-label">Contact Name:</Form.Label>
                        <Form.Control
                            type="text"
                            name="contactName"
                            value={formData.contactName}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Optional"
                        />
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label className="form-label">Password:</Form.Label>
                        <InputGroup className="password-input-group">
                            <Form.Control
                                type={showPassword ? "text" : "password"}
                                id="viewPassword"
                                name="password"
                                value={formData?.password || ''}
                                onChange={handleChange}
                                className="password-field"
                                autoComplete="new-password"
                                data-lpignore="true" 
                                data-form-type="other"  
                            />
                            <InputGroup.Text
                                className="password-toggle-btn"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <i className={`fas fa-${showPassword ? 'eye-slash' : 'eye'}`}></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Button
                            variant="dark"
                            onClick={generatePassword}
                            className="generate-btn w-100"
                            type="button"
                        >
                            Generate Password
                        </Button>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} className="modal-close-btn">
                    Cancel
                </Button>
                <Button
                    variant="success"
                    onClick={handleSubmit}
                    disabled={isLoading}
                    className="modal-action-btn"
                >
                    {isLoading ? 'Saving...' : 'Save'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PasswordFormModal;